var _circle, _g, _path, _rect, _ellipse, _path2, _path3, _rect2, _rect3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2127_207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3959 13.5478C19.3959 11.9511 20.6903 10.6566 22.2871 10.6566H25.8723C27.4691 10.6566 28.7635 11.9511 28.7635 13.5478V13.5478H19.3959V13.5478Z",
    fill: "url(#paint0_linear_2127_207)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.8873,
    y: 7.38867,
    width: 0.64162,
    height: 3.51974,
    fill: "url(#paint1_linear_2127_207)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.2078,
    cy: 6.3199,
    rx: 1.3474,
    ry: 1.3199,
    fill: "url(#paint2_linear_2127_207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7898 37.0002C10.714 36.9914 8.3362 32.6647 7.65633 30.5002C6.80564 30.5002 5.10425 30.1002 5.10425 28.5002V23.0002C5.2738 22.3358 6.2206 21.1087 8.65186 21.4961C9.93461 17.3169 14.0031 12.5466 23.9888 12.974C33.9718 12.5482 38.0391 17.3183 39.3214 21.4971C41.7571 21.1066 42.7054 22.3353 42.8751 23.0002V28.5002C42.8751 30.1002 41.1737 30.5002 40.323 30.5002C39.6424 32.6668 37.2605 37.0002 33.1772 37.0002H14.7898Z",
    fill: "url(#paint3_linear_2127_207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6876 37.0002H14.8022C10.7188 37.0002 8.33689 32.6669 7.65633 30.5002C6.80564 30.5002 5.10425 30.1002 5.10425 28.5002V23.0002C5.27439 22.3335 6.22716 21.1002 8.67716 21.5002M14.2917 37.0002H33.1772C37.2605 37.0002 39.6424 32.6668 40.323 30.5002C41.1737 30.5002 42.8751 30.1002 42.8751 28.5002V23.0002C42.7049 22.3335 41.7522 21.1002 39.3022 21.5002M8.16707 25C7.99693 20.6667 11.0251 12.2002 24.5001 13.0002M39.8059 25.0002C39.9761 20.6669 36.9479 12.2004 23.4729 13.0004",
    stroke: "url(#paint4_linear_2127_207)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3959 13.5478C19.3959 11.9511 20.6903 10.6566 22.2871 10.6566H25.8723C27.4691 10.6566 28.7635 11.9511 28.7635 13.5478V13.5478H19.3959V13.5478Z",
    fill: "url(#paint5_linear_2127_207)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.8873,
    y: 7.38867,
    width: 0.64162,
    height: 3.51974,
    fill: "url(#paint6_linear_2127_207)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.2078,
    cy: 6.3199,
    rx: 1.3474,
    ry: 1.3199,
    fill: "url(#paint7_linear_2127_207)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7896 37.0002C10.7139 36.9914 8.33607 32.6647 7.65621 30.5002C6.80551 30.5002 5.10413 30.1002 5.10413 28.5002V23.0002C5.27368 22.3358 6.22048 21.1087 8.65174 21.4961C9.93449 17.3169 14.003 12.5466 23.9887 12.974C33.9716 12.5482 38.0389 17.3183 39.3212 21.4971C41.757 21.1066 42.7053 22.3353 42.875 23.0002V28.5002C42.875 30.1002 41.1736 30.5002 40.3229 30.5002C39.6423 32.6668 37.2604 37.0002 33.177 37.0002H14.7896Z",
    fill: "url(#paint8_linear_2127_207)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 37.0002H14.802C10.7187 37.0002 8.33676 32.6669 7.65621 30.5002C6.80551 30.5002 5.10413 30.1002 5.10413 28.5002V23.0002C5.27426 22.3335 6.22704 21.1002 8.67704 21.5002M14.2916 37.0002H33.177C37.2604 37.0002 39.6423 32.6668 40.3229 30.5002C41.1736 30.5002 42.875 30.1002 42.875 28.5002V23.0002C42.7048 22.3335 41.752 21.1002 39.302 21.5002M8.16695 25C7.99681 20.6667 11.025 12.2002 24.5 13.0002M39.8058 25.0002C39.9759 20.6669 36.9478 12.2004 23.4728 13.0004",
    stroke: "url(#paint9_linear_2127_207)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.25,
    y: 19,
    width: 23.4792,
    height: 12,
    rx: 6,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.25,
    y: 19,
    width: 23.4792,
    height: 12,
    rx: 6,
    stroke: "url(#paint10_linear_2127_207)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6459 25.5C31.6459 26.3284 30.9603 27 30.1146 27C29.2689 27 28.5834 26.3284 28.5834 25.5C28.5834 24.6716 29.2689 24 30.1146 24C30.9603 24 31.6459 24.6716 31.6459 25.5Z",
    fill: "url(#paint11_linear_2127_207)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3959 25.5C19.3959 26.3284 18.7103 27 17.8646 27C17.0189 27 16.3334 26.3284 16.3334 25.5C16.3334 24.6716 17.0189 24 17.8646 24C18.7103 24 19.3959 24.6716 19.3959 25.5Z",
    fill: "url(#paint12_linear_2127_207)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2127_207",
    x1: 17.8646,
    y1: 12.3478,
    x2: 19.8987,
    y2: 15.9251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2127_207",
    x1: 23.7824,
    y1: 9.44753,
    x2: 24.3472,
    y2: 9.50341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2127_207",
    x1: 22.4199,
    y1: 6.54414,
    x2: 24.2522,
    y2: 7.55951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2127_207",
    x1: -1.06983,
    y1: 27.0169,
    x2: 18.3729,
    y2: 43.5896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2127_207",
    x1: -1.06983,
    y1: 27.0169,
    x2: 18.3729,
    y2: 43.5896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2127_207",
    x1: 17.8646,
    y1: 12.3478,
    x2: 19.8987,
    y2: 15.9251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2127_207",
    x1: 23.7824,
    y1: 9.44753,
    x2: 24.3472,
    y2: 9.50341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2127_207",
    x1: 22.4199,
    y1: 6.54414,
    x2: 24.2522,
    y2: 7.55951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2127_207",
    x1: -1.06995,
    y1: 27.0169,
    x2: 18.3728,
    y2: 43.5896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2127_207",
    x1: -1.06995,
    y1: 27.0169,
    x2: 18.3728,
    y2: 43.5896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2127_207",
    x1: 8.41206,
    y1: 26.0193,
    x2: 18.2182,
    y2: 36.4341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2127_207",
    x1: 28.0828,
    y1: 25.7548,
    x2: 30.1652,
    y2: 26.9087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2127_207",
    x1: 15.8328,
    y1: 25.7548,
    x2: 17.9152,
    y2: 26.9087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2127_207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.8125,
    height: 37,
    fill: "white",
    transform: "translate(4.08337 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatLogo);
export default __webpack_public_path__ + "static/media/chatLogo.4f7c94d5.svg";
export { ForwardRef as ReactComponent };